// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var CoursesApply__Form = require("./components/CoursesApply__Form.bs.js");
var EmailSentIconSvg = require("./images/email-sent-icon.svg").default;

((require("../shared/background_patterns.css")));

((require("./CoursesApply__Root.css")));

var emailSentIcon = EmailSentIconSvg;

function str(prim) {
  return prim;
}

function setViewEmailSent(setView, param) {
  return Curry._1(setView, (function (param) {
                return /* EmailSent */1;
              }));
}

function emailSentMessage(param) {
  return React.createElement("div", undefined, React.createElement("img", {
                  className: "mx-auto w-44 sm:w-48",
                  src: emailSentIcon
                }), React.createElement("div", {
                  className: "text-xl font-bold text-center mt-4"
                }, "We've sent you a verification mail."), React.createElement("p", {
                  className: "mt-4 text-center"
                }, "It should reach you in less than a minute. Click the link in the email to sign up, and get started."));
}

function CoursesApply__Root(Props) {
  var courseName = Props.courseName;
  var courseId = Props.courseId;
  var thumbnailUrl = Props.thumbnailUrl;
  var email = Props.email;
  var name = Props.name;
  var privacyPolicy = Props.privacyPolicy;
  var termsOfUse = Props.termsOfUse;
  var match = React.useState(function () {
        return /* Apply */0;
      });
  var setView = match[1];
  return React.createElement("div", {
              className: "flex min-h-screen bg-gray-100 items-center justify-center"
            }, React.createElement("div", {
                  className: "py-8 w-full"
                }, React.createElement("div", {
                      className: "container mx-auto px-3 max-w-lg"
                    }, React.createElement("div", {
                          className: "relative flex flex-col shadow-xl rounded-lg overflow-hidden bg-white border"
                        }, React.createElement("div", {
                              className: "flex flex-col text-gray-900 bg-gray-200 text-white"
                            }, React.createElement("div", {
                                  className: "relative pb-1/2 bg-primary-900"
                                }, thumbnailUrl !== undefined ? React.createElement("img", {
                                        className: "absolute h-full w-full object-cover",
                                        src: thumbnailUrl
                                      }) : React.createElement("div", {
                                        className: "course-apply__cover-default absolute h-full w-full svg-bg-pattern-1"
                                      }))), React.createElement("div", {
                              className: ""
                            }, React.createElement("div", {
                                  className: "p-4 pt-5 md:px-12 md:py-12 md:pt-10"
                                }, match[0] ? emailSentMessage(undefined) : React.createElement(CoursesApply__Form.make, {
                                        courseName: courseName,
                                        courseId: courseId,
                                        setViewEmailSent: (function (param) {
                                            return Curry._1(setView, (function (param) {
                                                          return /* EmailSent */1;
                                                        }));
                                          }),
                                        email: email,
                                        name: name
                                      })))), React.createElement("div", {
                          className: "text-center mt-4 text-gray-700"
                        }, termsOfUse ? React.createElement("a", {
                                className: "text-xs cursor-pointer hover:text-primary-500",
                                href: "/agreements/terms-of-use"
                              }, "Terms of Use") : null, termsOfUse && privacyPolicy ? React.createElement("span", {
                                className: "px-4 text-gray-500",
                                dangerouslySetInnerHTML: {
                                  __html: "&vert;"
                                }
                              }) : null, privacyPolicy ? React.createElement("a", {
                                className: "text-xs cursor-pointer hover:text-primary-500",
                                href: "/agreements/privacy-policy"
                              }, "Privacy Policy") : null))));
}

var make = CoursesApply__Root;

exports.emailSentIcon = emailSentIcon;
exports.str = str;
exports.setViewEmailSent = setViewEmailSent;
exports.emailSentMessage = emailSentMessage;
exports.make = make;
/*  Not a pure module */
